export default __webpack_public_path__ + "static/media/OfficerMeta.45f1e047.svg";